// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';
import { v1EntrySummarySchema } from './v1/entrySummarySchema';
import { v1UnauthorizedErrorSchema } from './v1/unauthorizedErrorSchema';

export const getEntrySummariesQueryParamsSchema = z.object({
  from: z.optional(z.string().date().describe("Start date (YYYY-MM-DD). Defaults to current date")),
  to: z.optional(z.string().date().describe("End date (YYYY-MM-DD). Defaults to current date")),
}).optional();

export const getEntrySummariesHeaderParamsSchema = z.object({
  Authorization: z.coerce.string().describe("OAuth 2.0 Bearer token"),
});

/**
 * @description Entry summaries
 */
export const getEntrySummaries200Schema = z.array(z.lazy(() => v1EntrySummarySchema));

/**
 * @description Unauthorized
 */
export const getEntrySummaries401Schema = z.lazy(() => v1UnauthorizedErrorSchema);

export const getEntrySummariesQueryResponseSchema = z.lazy(() => getEntrySummaries200Schema);
